import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const reactPlugin = new ReactPlugin();

const initializeAppInsights = () => {
	const instrumentationKey =
		process.env.REACT_APP_APP_INSIGHTS_INSTRUMENTATION_KEY;
	const isAppInsightsEnabled = process.env.REACT_APP_IS_APP_INSIGHTS_ENABLED;
	const browserHistory = createBrowserHistory({ basename: '' });

	if (isAppInsightsEnabled === 'false') return;

	if (!instrumentationKey)
		return console.error(
			'Application Insights Instrumentation key is not provided',
		);

	const appInsights = new ApplicationInsights({
		config: {
			instrumentationKey,
			extensions: [reactPlugin],
			disableFetchTracking: false,
			extensionConfig: {
				[reactPlugin.identifier]: { history: browserHistory },
			},
		},
	});

	appInsights.loadAppInsights();
};

initializeAppInsights();

export { reactPlugin };
